import publicService from "@/api/public";

export default {
  verify(accessCode) {
    return publicService
      .Api()
      .post("public/inboundDelivery/verify", { accessCode })
      .then((response) => response.data);
  },

  findProduct(accessCode, code) {
    return publicService
      .Api()
      .get("public/inboundDelivery/product", {
        params: { accessCode, code },
      })
      .then((response) => response.data);
  },

  submit(accessCode, data) {
    return publicService
      .Api()
      .post("public/inboundDelivery", { ...data, accessCode })
      .then((response) => response.data);
  },
};
